/**
 * @voltxampere/ui — AMS1117-5.0 +5V LDO regulator (Sprint 40-2)
 *
 * SOT-223 LDO, +5 V output, V_dropout ~ 1 V (V_in_min ~ 6 V),
 * I_max 1 A. Same package and family as AMS1117-3.3; differs only
 * in regulation set-point. Reuses the dc-source SVG; canonical
 * "voltage-source" engine type.
 *
 * Reference: AMS AMS1117-5.0 (Advanced Monolithic Systems). Engine
 * zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulatorAms1117_5v = {
    id: "ams1117-5v",
    nameTr: "AMS1117-5.0 (+5V LDO, SOT-223)",
    nameEn: "AMS1117-5.0 (+5V LDO, SOT-223)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "AMS1117-5.0",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-ams1117-5v.js.map